export class InstallationLocation {
  id?: number;
  zipCode?: string;
  location?: string;
}
